<template>
  <path
    d="M19 2.00018H5C3.89 2.00018 3 2.90018 3 4.00018V18.0002C3 19.1002 3.9 20.0002 5 20.0002H9L11.29 22.2902C11.68 22.6802 12.31 22.6802 12.7 22.2902L15 20.0002H19C20.1 20.0002 21 19.1002 21 18.0002V4.00018C21 2.90018 20.1 2.00018 19 2.00018ZM12 5.30018C13.49 5.30018 14.7 6.51018 14.7 8.00018C14.7 9.49018 13.49 10.7002 12 10.7002C10.51 10.7002 9.3 9.49018 9.3 8.00018C9.3 6.51018 10.51 5.30018 12 5.30018ZM18 16.0002H6V15.1002C6 13.1002 10 12.0002 12 12.0002C14 12.0002 18 13.1002 18 15.1002V16.0002Z"
  />
</template>
